import styled from '@emotion/styled';
import { Avatar } from '@mui/material';

const ButtonAvatar = styled(Avatar)`
  height: 42px;
  width: 42px;
  border-radius: 100%;
  background: #4c3b51;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding: 2px;
  overflow: visible;
`;
export const AvatarImage = styled.img`
  height: auto;
  max-width: 23px;
  margin: auto;
`;
export default ButtonAvatar;
